import {StyleSheet} from 'react-native';
import {styles} from 'src/theme';
import { customResponsiveWidth } from '../../../../utils/CustomResponsive';
import { windowWidth } from '../../../../constants';

export default StyleSheet.create({
  slide: {
    alignItems: 'center',
    height: '100%',
  },
  title: {
    color: '#303261',
    fontSize: 18,
    marginBottom: 14,
    fontFamily: styles.font.IranYekan[400],
  },
  text: {
    color: '#303261',
    fontSize: 14,
    marginBottom: 50,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
  },
  textContainer : {
    width : windowWidth - 30 , 
    alignItems : 'center'
  },
  buttontext: {
    fontSize: 18,
    fontFamily: styles.font.IranYekan[400],
  },
  btncontainer: {
    width: '100%',
    paddingHorizontal: 24,
    paddingBottom : 24 , 
    height : 120 , 
    position : 'absolute' , 
    bottom  : 0 , 
    justifyContent: 'flex-end',
  },
  imageContainer : {
    padding : 10 , 
    justifyContent : 'center' , 
    backgroundColor  :'#fff' , 
    alignItems  :'center' , 
    width : customResponsiveWidth(52) , 
    height : customResponsiveWidth(52) , 
    borderRadius : 18 , 
  }
});
